import React, { useState, useEffect } from "react";
import { AmbientData, AmbientDataDownload } from "../../Slices/ReportSlices";
import { useSelector, useDispatch } from "react-redux";
import jsPDF from "jspdf";
// import "jspdf-autotable"; // must come after jsPDF
import * as XLSX from "xlsx";



const AmbientDataDetails = ({
  selectedEnterprise,
  selectedCountryState,
  selectedLocation,
  selectedGateway,
  pstartDate,
  pendDate,
  settingsComplete,
}) => {
  const dispatch = useDispatch();

  const { enterprises } = useSelector((state) => state.enterpriseDataSlice);
  const { ambientData_response } = useSelector((state) => state.reportSlice);
  const { AmbientDataDownload_response } = useSelector((state) => state.reportSlice);

  const [ambientData, setAmbientData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const limit = 10;

  useEffect(() => {
    if (ambientData_response?.data) {
      setAmbientData(ambientData_response.data);
      setHasNextPage(ambientData_response.hasNextPage);
      // If hasNextPage is false and there is data, it's the last page
      setIsLastPage(!ambientData_response.hasNextPage && ambientData_response.data.length > 0);
    }
  }, [ambientData_response]);


  const selectedEnterpriseData = enterprises.find(
    (enterprise) => enterprise.entepriseId === selectedEnterprise
  );
  const countrystates = selectedEnterpriseData ? selectedEnterpriseData.states : [];
  const selectedCountryStateData = countrystates.find(
    (countrystate) => countrystate.stateId === selectedCountryState
  );
  const locations = selectedCountryStateData ? selectedCountryStateData.locations : [];
  const selectedLocationData = locations.find((location) => location.locId === selectedLocation);

  useEffect(() => {
    if (!selectedGateway || !pstartDate || !pendDate || !settingsComplete) return;

    const startDate = Math.floor(new Date(pstartDate).getTime() / 1000);
    const endDate = Math.floor(new Date(pendDate).getTime() / 1000);

    const header = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      },
    };

    const data = {
      gateway_id: selectedGateway,
      startDate,
      endDate,
      page,
      limit,
    };

    dispatch(AmbientData({ data, header }));
  }, [selectedGateway, pstartDate, pendDate, settingsComplete, page]);

  const handlePrevClick = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNextClick = () => {
    if (hasNextPage) setPage((prev) => prev + 1);
  };

  const handleDownloadAllExcel = async () => {
  const allData = [];


  const header = {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem("token")}`,
    },
  };

  const startDate = Math.floor(new Date(pstartDate).getTime() / 1000);
  const endDate = Math.floor(new Date(pendDate).getTime() / 1000);

 
    const data = {
      gateway_id: selectedGateway,
      startDate,
      endDate,
    };

    try {
      const result = await dispatch(AmbientDataDownload({ data, header })).unwrap();

      if (result?.data?.length) {
        allData.push(...result.data);
       
      } else {
        
      }
    } catch (err) {
      console.error("Download failed:", err);
    }
  

  if (allData.length === 0) {
    alert("No data found to download.");
    return;
  }

  const worksheetData = allData.map((log) => ({
    Enterprise: selectedEnterpriseData?.enterpriseName || "",
    State: selectedCountryStateData?.stateName || "",
    Location: selectedLocationData?.locationName || "",
    "Gateway ID": log.GatewayID || "",
    Date: new Date(log.TimeStamp * 1000).toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
    }),
    Time: new Date(log.TimeStamp * 1000).toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
    }),
    "Ambient Temp (°C)": log.AmbientTemp || "",
    "Humidity (%)": log.AmbientHumidity || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Ambient Data");

  XLSX.writeFile(workbook, `Ambient_Report_All_Data.xlsx`);
};

  return (
    <>
      <div className="px-2 py-4">

        {!settingsComplete && (
          <p className="text-gray-600 text-center">Please Fill the Fields to Get Ambient Data.</p>
        )}

        {ambientData.length === 0 && page === 1 && settingsComplete && (
          <p className="text-gray-600 text-center">No data available at the moment.</p>
        )}

        {ambientData.length > 0 && settingsComplete && (
          <>


            {/* Full-width responsive table */}
            <div
              className="download_btn "
              style={{ position: "sticky", top: "0", zIndex: "1000" }}
            >
              <button 
                type="button"
                className="py-2 px-3 mt-2 focus:outline-none text-white rounded-lg float-end mr-3 "
                onClick={ handleDownloadAllExcel}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4a90e2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 9l-5 5-5-5M12 12.8V2.5" />
                </svg>
              </button>
            

            <table className="w-full whitespace-no-wrap text-center">
              <thead>
                <tr className="text-xs font-semibold tracking-wide text-center text-gray-500 uppercase border-b bg-gray-50">
                  <th className="px-4 py-3">Enterprise</th>
                  <th className="px-4 py-3">State</th>
                  <th className="px-4 py-3">Location</th>
                  <th className="px-4 py-3">Gateway ID</th>
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3">Time</th>
                  <th className="px-4 py-3">Ambient Temp (°C)</th>
                  <th className="px-4 py-3">Humidity (%)</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y text-gray-800">
                {ambientData.map((log) => (
                  <tr key={log._id} className="hover:bg-gray-100">
                    <td className="px-4 py-3">{selectedEnterpriseData?.enterpriseName}</td>
                    <td className="px-4 py-3">{selectedCountryStateData?.stateName}</td>
                    <td className="px-4 py-3">{selectedLocationData?.locationName}</td>
                    <td className="px-4 py-3">{log.GatewayID}</td>
                    <td className="px-4 py-3">
                      {new Date(log.TimeStamp * 1000).toLocaleDateString("en-IN", {
                        timeZone: "Asia/Kolkata",
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                      })}
                    </td>
                    <td className="px-4 py-3">
                      {new Date(log.TimeStamp * 1000).toLocaleTimeString("en-IN", {
                        timeZone: "Asia/Kolkata",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      })}
                    </td>
                    <td className="px-4 py-3">{log.AmbientTemp}</td>
                    <td className="px-4 py-3">{log.AmbientHumidity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        {/* Pagination Section */}
        <div className="grid px-4 py-3 text-xs font-semibold tracking-wide text-gray-500 uppercase border-t bg-gray-50 sm:grid-cols-9">
          {/* Page info - left */}
          <span className="flex items-center col-span-3 text-base text-gray-700">
            {`Page No. ${page}`}
          </span>

          <span className="col-span-2"></span>

          {/* Prev/Next - right */}
          <span className="flex col-span-4 mt-2 sm:mt-auto sm:justify-end">
            <nav aria-label="Table navigation">
              <ul className="inline-flex items-center">
                <li>
                  <button
                    className={`py-2 px-3 mt-2 mr-3 focus:outline-none text-white rounded-lg ${page === 1
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-purple-600 hover:bg-purple-700"
                      }`}
                    aria-label="Previous"
                    onClick={handlePrevClick}
                    disabled={page === 1}
                    style={{
                      backgroundColor: page === 1 ? "#D1D5DB" : "",
                      color: page === 1 ? "#9CA3AF" : "",
                    }}
                  >
                    Prev
                  </button>
                </li>
                <li>
                  <button
                    className={`py-2 px-3 mt-2 focus:outline-none text-white rounded-lg ${isLastPage
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-purple-600 hover:bg-purple-700"
                      }`}
                    aria-label="Next"
                    onClick={handleNextClick}
                    disabled={isLastPage}
                    style={{
                      backgroundColor: isLastPage ? "#D1D5DB" : "",
                      color: isLastPage ? "#9CA3AF" : "",
                    }}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </span>
        </div>
      </>
        )}
    </div >
    </>
  );


};

export default AmbientDataDetails;
